import { render, staticRenderFns } from "./pref-facet-subject.vue?vue&type=template&id=51df7679&scoped=true&"
import script from "./pref-facet-subject.ts?vue&type=script&lang=ts&"
export * from "./pref-facet-subject.ts?vue&type=script&lang=ts&"
import style0 from "./pref-facet-subject.scss?vue&type=style&index=0&id=51df7679&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51df7679",
  null
  
)

export default component.exports